import React, { useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { FormattedMessage, useIntl } from "react-intl";
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import { useMemo } from "react";
import { TOTAL_STATUS_UNPAID } from "../../../../../utils/constant";
import moment from "moment";
import AddressEditor from "../../../../../../shoppingcart/fragments/address/address-editor";
import { useRef } from "react";
import { fetchUpdateShippingAddress, fetchUpdateBilingAddress } from "../../../../../../../../api";
import { useDispatch } from "react-redux";
import { setCustomerLoading, setOrderDetail } from "../../../../../../../../store/actions/pages/customer";
import Alert from "../../../../../../../components/alert";


const ShippingAddress = props =>{
    const { shippingDetail, editAddress, orderStatus } = props;

    const addressName = useMemo(() =>{
        return shippingDetail?.firstName ? `${shippingDetail?.firstName} ${shippingDetail?.lastName}` : shippingDetail?.name
    }, [shippingDetail]);

    const addressLabel = useMemo(() =>{
        if(shippingDetail?.unit){
            return shippingDetail.streetAddress1 + ', ' + shippingDetail.unit
        }
        return shippingDetail.streetAddress1
    }, [shippingDetail]);

    const stateCountry = useMemo(() =>{
        let state = shippingDetail?.state?.label || shippingDetail?.state?.value;
        let country = shippingDetail?.country.label || shippingDetail?.country?.value;
        if (state) {
            return `${state},${country}`;
        }
        return country;

    }, [shippingDetail]);

    return <div className={cls.OrderAddress}>
        <div className={cls.Title}>{props.title}</div>

        <div className={cls.AddressContainer}>
            <div className={cls.Left}>
                <Iconfont className={cls.Icon}>&#xe691;</Iconfont>
            </div>

            <div>
                <p className={cls.Font1}>{addressName} ({shippingDetail?.phoneNumber})</p>
                <p className={cls.Font2}>{addressLabel}</p>
                <p className={cls.Font2}>{shippingDetail?.zipCode}, {shippingDetail?.city},{stateCountry}</p>
            </div>
        </div>

        {
            orderStatus === TOTAL_STATUS_UNPAID && <Iconfont className={cls.EditIcon} onClick={editAddress}>&#xe778;</Iconfont>
        }
    </div>
}

const PaymentMethod = props =>{
    const { paymentMethod } = props;

    return <div className={cls.PaymentMethod}>
        <div className={cls.Title}><FormattedMessage id="payment_method" defaultMessage="Payment method" /></div>

        <div className={cls.Content}>
            <img src={paymentMethod.icon} alt={paymentMethod.name} />
            <span>{paymentMethod.name}</span>
        </div>
    </div>
}

const ShippingMethod = props =>{

    return <div className={cls.ShippingMethod}>
        <div className={cls.Title}>
            {props.title}
        </div>

        <div className={cls.Content}>
            {props.children}
        </div>
    </div>
}

export default props =>{
    useStyles(cls);
    const { orderDetail } = props;
    const Intl = useIntl();
    const [addressEditor, setAddressEditor] = useState({});
    const shippingTypeRef = useRef(0);
    const disptach = useDispatch();

    const editAddress = (address, type) =>{
        setAddressEditor({ address, show: true });
        shippingTypeRef.current = type;
}

    const onSubmitAddress = async (values) =>{
        try {
            let response;
            disptach(setCustomerLoading(true));
            let params = { ...values, transactionId: orderDetail?.transactionId };
            if(shippingTypeRef.current === 1){
                response = await fetchUpdateShippingAddress(params);
                if(response?.code === 200 && response?.result){
                    let value = { ...orderDetail, shippingDetail: response.result };
                    disptach(setOrderDetail(value));
                    setAddressEditor({ address: null, show: false });
                }else{
                    response?.result && Alert(response.result);
                }
            }else if(shippingTypeRef.current === 2){
                response = await fetchUpdateBilingAddress(params);
                if(response?.code === 200 && response?.result){
                    let value = { ...orderDetail, billingAddress: response.result };
                    disptach(setOrderDetail(value));
                    setAddressEditor({ address: null, show: false });
                }else{
                    response?.result && Alert(response.result);
                }
            }
            disptach(setCustomerLoading(false));

            return response;
        } catch (error) {
            console.log('error', error)
        }
    }

    return <div className={cls.ShippingDetail}>
        <ShippingAddress 
            shippingDetail={orderDetail?.shippingDetail} 
            title={Intl.formatMessage({ id: "shipping_address", defaultMessage: "Shipping Address" })} 
            editAddress={()=>editAddress(orderDetail?.shippingDetail, 1)} 
            orderStatus={orderDetail?.fulfillmentStatus}
        />

        {
            orderDetail?.billingAddress && <React.Fragment>
                <ShippingAddress 
                    shippingDetail={orderDetail.billingAddress} 
                    title={Intl.formatMessage({ id: "billing_address", defaultMessage: "Billing Address" })} 
                    editAddress={()=>editAddress(orderDetail.billingAddress, 2)} 
                    orderStatus={orderDetail?.fulfillmentStatus}
                />
            </React.Fragment>
        }
        
        {
            orderDetail?.payMethodInfo && <PaymentMethod paymentMethod={orderDetail.payMethodInfo} />
        }

        {
            orderDetail?.shippingMethodName && <ShippingMethod title={Intl.formatMessage({ id: "shipping_method", defaultMessage: "Shipping Method" })}>{orderDetail.shippingMethodName}</ShippingMethod>
        }

        {
            orderDetail?.estimatedDelivery?.startDate && <React.Fragment>
                <ShippingMethod 
                    title={Intl.formatMessage({ id: "delivery_time", defaultMessage: "Delivery Time" })}
                >
                    <FormattedMessage id="about" defaultMessage="About" /> {moment(orderDetail.estimatedDelivery.startDate).format('DD/MM/YYYY')} {moment(orderDetail.estimatedDelivery?.endDate).format('DD/MM/YYYY')}
                </ShippingMethod>
            </React.Fragment>
        }


        <AddressEditor country={global?.country} address={addressEditor?.address} onSubmit={onSubmitAddress} onClose={e => setAddressEditor({ ...addressEditor, show: false })} show={addressEditor?.show} />
    </div>
}